// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__TDkVM","upload":"Small_upload__2QqrD","imageWrap":"Small_imageWrap__2CRca","removeBtn":"Small_removeBtn__2GSUX"};